import {AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, ViewEncapsulation} from '@angular/core';

import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import Swal from 'sweetalert2';
import {merge, Subject} from 'rxjs';
import {tap} from 'rxjs/operators';
import {UtilMessage} from '../../util/util-message';
import {MatDialog} from '@angular/material/dialog';
import {ExecutorFilter} from '../../util/executor-filter';
import {FilterSearch} from '../model/filtro.model';
import {EventService} from './event.service';
import {fuseAnimations} from '../../../@fuse/animations';
import {FilterEventDialog} from './filter/filter-event-dialog.component';
import {EventModel, StatusEvent} from "../model/event.model";
import {StatusAnnouncement} from "../model/announcement.model";

@Component({
    selector: 'event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class EventComponent implements AfterViewInit, OnDestroy, ExecutorFilter {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;

    dataSource = new Array<EventModel>();
    searchText = '';
    lengthItems = 0;
    columns = ['id', 'image', 'title', 'description',  'status', 'user', 'date', 'buttons'];

    private _unsubscribeAll: Subject<any>;

    constructor(private _service: EventService, private _message: UtilMessage, private dialog: MatDialog) {
        this._unsubscribeAll = new Subject();
    }

    ngAfterViewInit(): void {
        this.paginator._intl.itemsPerPageLabel = 'Itens por página:';
        this.paginator.pageIndex = 0;
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        this.search();

        merge(this.sort.sortChange, this.paginator.page).pipe(tap(() => this.loadEvents(new Array<FilterSearch>()))).subscribe();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    loadEvents(filters: Array<FilterSearch>): void {
        const request = {
            page: this.paginator.pageIndex,
            size: this.paginator.pageSize,
            sort: this.sort.active ? this.sort.active + ',' + this.sort.direction : 'id,asc'
        };

        this._service.query(request, filters).subscribe(
            (res: HttpResponse<EventModel[]>) => {
                this.lengthItems = parseInt(res.headers.get('X-Total-Count'), 10);
                this.dataSource = res.body;
            },
            (res: HttpErrorResponse) => Swal.fire('Erro...', res.message, 'error')
        );
    }

    search(): void {
        const filters = new Array<FilterSearch>();
        filters.push(new FilterSearch('search', this.searchText));
        this.loadEvents(filters);
    }

    delete(id: number): void {
        Swal.fire({
            title: 'Você tem certeza?',
            text: 'Você não poderá reverter isso!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Excluir'
        }).then((result) => {
            if (result.isConfirmed) {
                this._service.delete(id).toPromise()
                    .then(() => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Registro removido com sucesso!',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        this.loadEvents(new Array<FilterSearch>());
                    }).catch(error => Swal.fire('Erro...', 'Não foi possível remover!', 'error'));
            }
        });
    }

    clear(): void {
        this.searchText = '';
        this.search();
    }

    openFilter(): void {
        const dialogRef = this.dialog.open(FilterEventDialog, {
            width: '30%',
            disableClose: true
        });
        dialogRef.componentInstance.executorFilter = this;
    }

    executeFilter(filters: Array<FilterSearch>): void {
        this.loadEvents(filters);
    }

    getTextStatus(status?: StatusEvent): string {
        switch (status) {
            case StatusEvent.EM_ANALISE:
                return 'Em Análise';
            case StatusEvent.REJEITADO:
                return 'Rejeitado';
            default:
                return 'Liberado';
        }
    }

    getImageUrl(id: number): string {
        return `https://chibarro-grei-prod-public-assets.s3.amazonaws.com/events/${id}.png?v=${new Date().getTime()}`;  // Adiciona um timestamp
    }
}
